import { render, staticRenderFns } from "./SpeakerStats.vue?vue&type=template&id=509df7ec"
import script from "./SpeakerStats.vue?vue&type=script&lang=js"
export * from "./SpeakerStats.vue?vue&type=script&lang=js"
import style0 from "./SpeakerStats.vue?vue&type=style&index=0&id=509df7ec&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('509df7ec')) {
      api.createRecord('509df7ec', component.options)
    } else {
      api.reload('509df7ec', component.options)
    }
    module.hot.accept("./SpeakerStats.vue?vue&type=template&id=509df7ec", function () {
      api.rerender('509df7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Meet/Modal/SpeakerStats.vue"
export default component.exports